import { render, staticRenderFns } from "./二级页.vue?vue&type=template&id=2346fd7a&scoped=true&"
import script from "./二级页.vue?vue&type=script&lang=js&"
export * from "./二级页.vue?vue&type=script&lang=js&"
import style0 from "./二级页.vue?vue&type=style&index=0&id=2346fd7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2346fd7a",
  null
  
)

export default component.exports